import { BaJwt } from "@oiambk/oiam-oauth-types";
export class JwtUtil {
    static authnLevels = new Map([
        ['STORK-QAA-Level-1', 'basis'],
        ['STORK-QAA-Level-2', 'normal'],
        ['STORK-QAA-Level-3', 'substanziell'],
        ['STORK-QAA-Level-4', 'hoch'],
    ]);
    /**
     * Get the payload from a jwt-string
     * @param tokenEventType
     */
    static parseBAJwt(tokenEventType) {
        if (tokenEventType != null && tokenEventType.jwt != null) {
            return new BaJwt(tokenEventType.jwt);
        }
        return null;
    }
    /**
     * Checks if the tokenEvent has a valid token with jwt-version 2.9
     *
     * returns the result and optionally the jwt, if found.
     *
     * @param tokenEvent
     */
    static validateJwt = (tokenEvent) => {
        // if the token is empty, the user is not logged in yet
        if (tokenEvent.detail?.jwt) {
            const jwt = JwtUtil.parseBAJwt(tokenEvent.detail);
            if (jwt && jwt.payload && jwt.payload['jwt-version'] && !jwt.payload['jwt-version'].startsWith('2.4')) {
                return { isValidJwt: true, jwt: jwt };
            }
        }
        return { isValidJwt: false };
    };
    static isValidAuthnLevel(level) {
        return ['STORK-QAA-Level-1', 'STORK-QAA-Level-2', 'STORK-QAA-Level-3', 'STORK-QAA-Level-4'].some((l) => l === level);
    }
}
